export var EndpointCommand;
(function (EndpointCommand) {
    EndpointCommand["invokeCCAPI"] = "endpoint.invoke_cc_api";
    EndpointCommand["supportsCCAPI"] = "endpoint.supports_cc_api";
    EndpointCommand["supportsCC"] = "endpoint.supports_cc";
    EndpointCommand["controlsCC"] = "endpoint.controls_cc";
    EndpointCommand["isCCSecure"] = "endpoint.is_cc_secure";
    EndpointCommand["getCCVersion"] = "endpoint.get_cc_version";
    EndpointCommand["getNodeUnsafe"] = "endpoint.get_node_unsafe";
    EndpointCommand["tryGetNode"] = "endpoint.try_get_node";
    EndpointCommand["setRawConfigParameterValue"] = "endpoint.set_raw_config_parameter_value";
    EndpointCommand["getRawConfigParameterValue"] = "endpoint.get_raw_config_parameter_value";
    // Undocumented
    EndpointCommand["getCCs"] = "endpoint.get_ccs";
    // Undocumented
    EndpointCommand["maySupportBasicCC"] = "endpoint.may_support_basic_cc";
    // Undocumented
    EndpointCommand["wasCCRemovedViaConfig"] = "endpoint.was_cc_removed_via_config";
})(EndpointCommand || (EndpointCommand = {}));
